<template>
  <article class="promotion-card" @click.prevent="emit('submit')">
    <!-- 배경이미지 -->
    <div class="banner-item banner-left">
      <div class="banner-txt-wrap">
        <h4 class="tit-h4 mb-1">{{ title }}</h4>
        <p>{{ subtitle }}</p>
      </div>
      <button v-if="buttonText" class="white-btn l-btn">{{ buttonText }}</button>
    </div>
    <div class="banner-item banner-object">
      <img src="/public/images/dashboard/plan-keyvisual.svg" alt="" />
    </div>
  </article>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';

const props = defineProps<{
  title?: string;
  subtitle?: string;
  backgroundImage?: string;
  videoSrc?: string;
  buttonText?: string;
}>();

const emit = defineEmits<{ submit: [] }>();

const videoRef = ref<HTMLVideoElement | null>(null);
const isPlaying = ref(false);
const hasPlayedOnce = ref(false);

onMounted(() => {
  if (!videoRef.value) return;

  const video = videoRef.value;

  isPlaying.value = true;
  video.currentTime = 0;

  video
    .play()
    .then(() => {
      video.onended = () => {
        isPlaying.value = false;
        hasPlayedOnce.value = true;
        video.currentTime = 0;
      };
    })
    .catch(() => {
      // autoplay 실패 → hover에서만 재생
      isPlaying.value = false;
    });
});
</script>

<style scoped lang="scss">
.promotion-card {
  position: relative;
  min-height: 180px;
  border-radius: 1.25rem;
  padding: 0 80px;
  overflow: hidden;
  cursor: pointer;
  background: linear-gradient(90deg, rgba(60, 61, 68, 1) 0%, rgba(76, 77, 83, 1) 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 48px 0;
  .banner-left {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    column-gap: 2rem;
    row-gap: $size-s;
    .banner-txt-wrap {
      h4 {
        color: #fff;
        white-space: nowrap;
      }
      p {
        color: rgba(255, 255, 255, 0.7);
        font-weight: 400;
      }
    }
    .white-btn {
      width: auto;
      background: #fff;
      padding: 0 1.25rem;
      font-weight: 600;
    }
  }
  .banner-object {
    text-align: right;
    animation: floatY 2s ease-in-out infinite;
  }
  @include respond-to(tablet) {
    padding: 0 40px;
    .banner-left {
      .banner-txt-wrap {
        text-align: center;
        h4 {
          font-size: $font-size-h5;
          white-space: wrap;
        }
        p {
          font-size: $font-size-psmall;
        }
      }
    }
  }
}

@keyframes floatY {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0);
  }
}

.card-art {
  position: relative;
  width: 100%;
  height: 100%;
}

/* Mobile: 1개 */
@media (max-width: 640px) {
  .promotion-card {
    flex-direction: column-reverse;
    justify-content: flex-start;
    padding: 2rem;
    gap: 2rem;
    margin: 1rem 0 2.5rem;
    .banner-left {
      flex-direction: column;
      row-gap: 1rem;
      .white-btn {
        width: 100%;
      }
    }
  }
}
</style>
